import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule, ListboxModule, SvgIconModule } from '@hdms/shared/ui-core';

import { SelectCurrencyComponent } from './select-currency.component';

@NgModule({
  declarations: [SelectCurrencyComponent],
  imports: [CommonModule, ListboxModule, ButtonModule, SvgIconModule],
  exports: [SelectCurrencyComponent]
})
export class SelectCurrencyModule {}
